
if (!customElements.get("ud-product-review-widget")) {
  class ReviewsWidgetComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      return;
    }

    // need to reinitialize the widget when the widget is disconnected
    disconnectedCallback() {
      this.initializeWidget();
      return;
    }

    initializeWidget() {
      this.connectedCallback();
      return;
    }
  }

  customElements.define("ud-product-review-widget", ReviewsWidgetComponent);
}

